import snq from 'snq';
function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const extractError = response => {
  const excpMessage = snq(() => response.data.ExceptionMessage);
  let jsonMessage = snq(() => excpMessage[1].split('{')[1]);
  if (jsonMessage) {
    jsonMessage = '{' + jsonMessage;
  }

  return isJsonString(jsonMessage) ? snq(() => JSON.parse(jsonMessage).error) : excpMessage[1];
};

export const getExtraError = str =>
  snq(() => {
    const string = snq(() => Object.values(JSON.parse(str).error)[0][0]);
    return string;
  });
